module.exports = __webpack_public_path__ + "static/media/pdf-big.4d5a6ac2.svg";